function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 16 16"
}, props), React.createElement("g", {
  fill: "#5F6C72"
}, React.createElement("path", {
  d: "M.118 8a.882.882 0 111.764 0v5.236c0 .487.395.882.882.882h10.472a.882.882 0 00.882-.882V8a.882.882 0 011.764 0v5.236a2.646 2.646 0 01-2.646 2.646H2.764a2.646 2.646 0 01-2.646-2.646V8zM8 2.247L5.124 5.124a.882.882 0 11-1.248-1.248l3.5-3.5a.882.882 0 011.248 0l3.5 3.5a.882.882 0 01-1.248 1.248L8 2.247z"
}), React.createElement("path", {
  d: "M7.118 1a.882.882 0 111.764 0v9.333a.882.882 0 11-1.764 0V1z"
}))));